import { Button } from '@design/components/button/Button';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './ResetAllButton.module.scss';

export interface ResetAllButtonProps {
  resetToSaved?: boolean;
  resetActiveFilterOptions: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const ResetAllButton = ({
  resetActiveFilterOptions,
  resetToSaved = false,
}: ResetAllButtonProps) => {
  const { t } = useTranslation(['screener']);

  return (
    <Button
      className={styles.resetButton}
      data-testid="reset-all"
      label={resetToSaved ? t('screener:resetSaved') : t('screener:clearAll')}
      iconName={resetToSaved ? 'Reset' : 'Clear'}
      iconPosition="left"
      variant="empty"
      size="small"
      onClick={resetActiveFilterOptions}
    />
  );
};
